import { Icons } from './icons';

/**
 * Canonical icon per module — the single source of truth for "what does this
 * module look like" wherever a module needs to represent itself visually
 * (AppShell nav, list/detail/editor Subheaders, etc.). Consume this instead of
 * reaching into `Icons` directly for a module identity: `Icons` has several
 * similarly-named entries per module (e.g. `checklist`/`checklists`/
 * `checklistOutlined`) that are easy to mismatch across a module's own list,
 * detail, and editor views — this map is the one place that choice is made.
 */
export const moduleIcons = {
  dashboard: Icons.home,
  analytics: Icons.analytics,
  contacts: Icons.contacts,
  packets: Icons.packets,
  checklists: Icons.checklists,
} as const;
